import ResultsWeights from './ResultsWeights';

export default ResultsWeights;
